<template>
    <div>
        <ProductsNav />
        <main class="col-lg-10 col-md-9 col-sm-9 left_gutter fill">
            <h1>Curb Adapters</h1>

            <img :src="`${$cdiVars.BASE_URL}/images/v3/cdi_products_adapters.jpg`" class="img-responsive img_content_right">

            <ul class="list_content">
                <li>Hybrid (Roof-in version) Curb Adapter</li>
                <li>Concentric Curb Adapter</li>
            </ul>
        </main>
    </div>
</template>

<script>
import ProductsNav from '@/components/content/ProductsNav.vue'
export default {
    name: "Adapters",
    components: {
        ProductsNav,
    },
    created() {
        this.$appStore.setTitle(['Curb Adapters']);
    },
}
</script>

<style scoped>

</style>